module.exports = __webpack_public_path__ + "img/guide_dir_09.f5e0a747.png";